import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import About from "../containers/About"

type AboutPageProps = {}

const AboutPage: React.FunctionComponent<AboutPageProps> = props => {
  return (
    <Layout>
      <SEO
        title="About Me"
        description="Started with solving problems with LEGO, 20 years ago. Then with chemical compounds 7 years ago. Then with programming 4 years ago. I'm sticking with it. I just love software."
      />

      <About />
    </Layout>
  )
}

export default AboutPage
